export default String.raw`
{% assign loopStart = forloop.index0 -%}
{% assign loopEnd = order.Products | Size | Minus: 1 -%}

{% assign productNames = '' -%}

{% assign productsSize = order.Products | Size -%}

{% assign price = product.Price | Minus: product.Price -%}
{% assign productValue = product.Value | Minus: product.Value -%}
{% assign priceBefore = product.ValueBeforeDiscount | Minus: product.ValueBeforeDiscount -%}

{% if config.ENTERPRISE -%}
    {% assign totalPrice = product.TotalPrice | Minus: product.TotalPrice -%}
    {% assign totalValue = product.TotalValue | Minus: product.TotalValue -%}
{% endif -%}

{% assign canReturnSet = false -%}
{% for setElIndex in (loopStart..loopEnd) -%}
    {% assign setEl = order.Products[setElIndex] -%}   
    {% if setEl.IsSetParent and setEl.CanReturn -%}
        {% assign canReturnSet = true -%}
    {% endif -%}
    {% if setEl.IsSetElement == false or (setEl.IsSetParent and setElIndex > loopStart) -%}
        {% break -%}
    {% endif -%}
    {% if config.ENTERPRISE -%}
        {% assign price = price | Plus: setEl.SubtotalPrice -%}
        {% assign productValue = productValue | Plus: setEl.SubtotalValue -%}
        {% assign priceBefore = priceBefore | Plus: setEl.SubtotalValueBeforeDiscount -%}
        {% assign totalPrice = totalPrice | Plus: setEl.TotalPrice -%}
        {% assign totalValue = totalValue | Plus: setEl.TotalValue -%}
    {% else -%}
        {% assign price = price | Plus: setEl.Price -%}
        {% assign productValue = productValue | Plus: setEl.Value -%}
        {% assign priceBefore = priceBefore | Plus: setEl.ValueBeforeDiscount -%}
    {% endif -%}

    {% assign productNameHTML = setEl.NameNoHtml | Prepend: '<li>' | Append: '</li>' -%}
    {% assign productNames = productNames | Append: productNameHTML -%}
{% endfor -%}

<td></td>

<td>
    <div class="product-cell name-and-code-js">
		<div class="image">
            {% if product.AskForPrice -%}
                <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high"/>
            {% elseif product.ImageId != -1 -%}
                {{ product | Img: 'small' }}
            {% else -%} 
                <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high"/>
            {% endif -%}
		</div>
		<div class="product-info">
            {% if product.AskForPrice -%}
                <a class="product-name" href="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?offerId={{ product.AskForPriceId }}&deeper-lvl&tab=offer-details&from-cart=true" rel="nofollow">{{ product.SetName }}</a>
            {% elseif product.Url -%}
                <a class="product-name" href="{{ page.BaseHref }}{{ product.Url }}">{{ product.SetName }}</a>
			{% else -%}
				<div>{{ product.SetName }}</div>
			{% endif -%}
			<ul>
				<li class="product-code">{{translations.Set}}</li>
			</ul>
		</div>
	</div>
</td>

<td></td>

{% if config.ENTERPRISE -%}
    <td></td>
{% endif -%}

<td></td>

{% if product.DepositValue > 0 -%}
    <td></td>
{% endif -%}

<td class="prices-view-js">
    <span>
        1
    </span>
    <span>
        {% if product.AskForPrice -%}
            {{translations.OfferShort}}
        {% else -%}
            {{translations.Set}}
        {% endif -%}
    </span>
</td>

{% unless customer.Cart.Inquiry -%}
    {% if isDiscount -%}
        <td></td>
    {% endif -%}
{% endunless -%}

<td class="prices-view-js">
    <span>{{productValue}}</span>
</td>

{% if config.ENTERPRISE -%}
    <td class="prices-view-js">
        {{ totalValue | ToPrice}}
    </td>
{% endif -%}

<td class="prices-view-js">
    {{ order.CurrencyExt }}
</td>

<td></td>

<td>
    {% if order.Status == 3 and config.Complaints.ComplaintsEnabled -%}
        {% if canReturnSet -%}
            <div class="options drop">
                <button aria-label="{{translations.Options}}" class="pure-button open-dropdown-js">
                    <svg width="24" height="24" style="transform: rotate(90deg);">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-h-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
                <div class="dropdown dropdown-js hidden-js">
                    <button class="pure-button open-complaint-form-js" data-class="complaint-form-js" data-type="set-return">
                        {{ translations.Return }}
                    </button>
                </div>
                <div class="open-complaint-form-container-js opening-modal-js open-complaint-form-js">
                    {% include 'partials/customer-profile/complaints/complaint-form.html' with 'set-return' -%}
                </div>
            </div>
        {% endif -%}
    {% endif -%}
</td>
`